import { ApiBase } from 'utils/api';


export default class LedgerApi {
    private base: ApiBase;

    constructor(base: ApiBase) {
        this.base = base;
    }

    transactions = (id: number) => this.base.axios
        .get(`/api/transactions/${id}`)
        .then(res => res.data);

    transactionsDownload = (id: number) => this.base.axios
        .get(`/api/transactions/${id}/f`,
            {
                responseType: 'blob',
            });
}
